// shared/hooks/useTravelPostQuoteData.ts

import { usePosterReducers } from "@/shared/redux/store/useGetData";
import { useMemo } from "react";

export function useTravelPostQuoteData() {
  const {
    travelQuote: { travelDetails },
  } = usePosterReducers();

  const isInbound = useMemo(() => {
    const normalizedCoverageLabel = String(travelDetails?.coverageLabel || "")
      .trim()
      .toLowerCase();

    return normalizedCoverageLabel.endsWith("inbound");
  }, [travelDetails?.coverageLabel]);

  return {
    travelDetails,
    isInbound,
  };
}
